"use client";

/**
 * CircleLoader — reusable full-page circle spinner.
 *
 * Renders a centered spinning circle with the brand gold / navy colours.
 * Use this in place of skeleton shimmer blocks while data is fetching.
 *
 * @param {string}  className   Extra Tailwind classes for the wrapper.
 * @param {boolean} fullScreen  When true (default) the loader takes the full
 *                              viewport height; when false it fills its parent.
 */
export default function CircleLoader({ className = "", fullScreen = true }) {
  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? "min-h-screen" : "min-h-75 w-full"
      } ${className}`}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#D4AF37] border-t-transparent" />
        <p className="text-sm font-medium tracking-wide text-gray-400">
          Loading…
        </p>
      </div>
    </div>
  );
}
